import { Component, State, h, Host, Element, Watch, Prop } from '@stencil/core';
import { state, onChange } from './pn-mainnav-store';
import { arrow_left } from 'pn-design-assets/pn-assets/icons.js';

@Component({
  tag: 'pn-mainnav-level',
  styleUrl: 'pn-mainnav-level.scss',
  shadow: false,
})
export class PnMainnavLevel {
  @Element() hostElement: HTMLElement;
  @Prop({ reflect: true, mutable: true }) label: string = '';
  @State() level: number = 1;
  @State() levelId: string = '';
  @State() isOpen: boolean = false;
  @State() parentName: string = '';
  @State() parentHref: string = '';
  @State() parentLinkId: string = '';
  @State() listCount: number = 0;
  @State() alignment: string = 'right';

  async componentWillLoad() {
    this.setState();
    onChange('openLevel', () => {
      this.onChangeOpenLevel();
    });
  }

  @Watch('label')
  setState() {
    this.listCount = this.hostElement.querySelectorAll(':scope > pn-mainnav-list').length;
    const parentElm = this.hostElement.parentElement;
    if (parentElm.tagName.toLowerCase() !== 'nav') {
      this.level = 2;
    }
    if (parentElm.tagName.toLowerCase() === 'pn-mainnav-link') {
      this.parentName = parentElm.getAttribute('name') + '';
      if ((!this.label && this.parentName) || this.label !== this.parentName) {
        this.label = this.parentName;
      }
      this.parentHref = parentElm.getAttribute('href') + '';
      this.parentLinkId = parentElm.getAttribute('linkid') + '';
      const parentLinkName = this.parentName.toLowerCase().replace(/\W/gi, '_');
      this.levelId = `mainnav-lvl${this.level}-${parentLinkName}`;
    }
  }

  @Watch('isOpen')
  onOpen() {
    if (this.level === 2) {
      requestAnimationFrame(() => {
        const levelClientRect = this.hostElement.getClientRects()[0];
        if (!levelClientRect) {
          return;
        }

        const navElm = this.hostElement.parentElement.parentElement.parentElement.parentElement;
        if (navElm && navElm.tagName.toLowerCase() === 'nav') {
          const navClientRect = navElm.getClientRects()[0];
          if (!navClientRect) {
            return;
          }

          if (levelClientRect.right > window.innerWidth) {
            const levelParentRect = this.hostElement.parentElement.getClientRects()[0];
            if (levelParentRect.left - levelClientRect.width < 0) {
              this.alignment = 'center';
            } else {
              this.alignment = 'left';
            }
          }
        }
      });
    }
  }
  onChangeOpenLevel() {
    this.isOpen = state.openLevel === this.levelId;
    state.currentLevel = this.level;
  }

  render() {
    return (
      <Host
        {...(this.level > 1 && this.levelId ? { 'aria-hidden': !this.isOpen + '' } : {})}
        data-level-listcount={this.listCount + ''}
        data-level-alignment={this.alignment}
        data-level={this.level + ''}
        {...(this.levelId ? { id: this.levelId } : {})}
      >
        {this.level > 1 ? (
          <div class="mainnav-level-header">
            <label htmlFor={this.levelId}>{state.i18n.menuGoBackButton}</label>
            <button
              class="secondlevel-backbtn"
              onClick={() => {
                state.openLevel = '';
                state.currentLevel = 1;
              }}
              aria-expanded={(state.openLevel === this.levelId) + ''}
            >
              <pn-icon icon={arrow_left} color="blue700" />
              {state.i18n.menuStartButton}
            </button>
            {this.parentHref && this.label ? <pn-mainnav-link href={this.parentHref} name={this.label} linkid={this.parentLinkId}></pn-mainnav-link> : null}
          </div>
        ) : null}
        <slot name="top"></slot>
        <slot></slot>
        <slot name="additional"></slot>
        <slot name="footer"></slot>
      </Host>
    );
  }
}
